type EmptyStateProps = {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
};

export default function EmptyState({ title, description, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="grid h-14 w-14 place-items-center rounded-full bg-secondary-100 text-secondary-600">
        <i className="ri-film-line text-2xl" />
      </span>
      <h3 className="mt-4 text-base font-semibold text-foreground-900">{title}</h3>
      {description && <p className="mt-2 max-w-md text-sm leading-6 text-foreground-500">{description}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 cursor-pointer whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-primary-950 transition-colors hover:bg-accent-400"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}